import classNames from "classnames";
import { Slider } from "components/DesignSystem/Slider/Slider";

export const ChatActionCentreSliderWrapper = ({
  children,
  sliderOpen,
  block = false,
  className,
  withSlider,
}: {
  children: React.ReactNode;
  sliderOpen: boolean;
  block?: boolean;
  className?: string;
  withSlider?: boolean;
}) => {
  if (!withSlider) {
    return <div className="t-w-full">{children}</div>;
  }

  return (
    <Slider
      open={sliderOpen}
      className={classNames(
        "t-absolute !t-p-0 t-shadow-slider t-z-10 t-h-screen",
        {
          "t-w-full": block,
          "t-w-[360px] sm:t-w-full": !block,
          [className || ""]: Boolean(className),
        }
      )}
      position="right"
      width={360}
    >
      {children}
    </Slider>
  );
};
